/**
 * home module router
 */

import { RouteConfig } from "vue-router";

function getView(viewName) {
  return (resolve, reject) => {
    require.ensure(
      [],
      require => {
        let map = {
          home: require("views/Home"), // 首页
          detail: require("views/Detail"), // 文章详情页
          product: require("views/Product"), // 产品服务
          about: require("views/About"), // 关于我们
          warn: require("views/Warn"), // 风险警示
          feedback: require("views/Feedback"), // 反馈
          join: require("views/Join"), // 加入我们
          recruit: require("views/Recruit"), // 职位
          jobDetails: require("views/JobDetails"), // 职位详情
          resumes: require("views/Resumes") // 简历投递
        };

        resolve(map[viewName]);
      },
      reject,
      "home"
    );
  };
}

let routes: RouteConfig[] = [
  {
    name: "home",
    path: "/"
  },
  {
    name: "detail",
    path: "/detail"
  },
  {
    name: "product",
    path: "/product"
  },
  {
    name: "about",
    path: "/about"
  },
  {
    name: "warn",
    path: "/about/warn"
  },
  {
    name: "feedback",
    path: "/feedback"
  },
  {
    name: "join",
    path: "/join"
  },
  {
    name: "recruit",
    path: "/recruit"
  },
  {
    name: "jobDetails",
    path: "/jobDetails"
  },
  {
    name: "resumes",
    path: "/resumes"
  },
  {
    name: "defaultView",
    path: "*"
  }
];

routes.forEach(v => {
  if (!v.redirect && !v.component) {
    v.component = getView(v.name);
  }
});

export default routes;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/home.ts